export default [
  {
    address: 'Красноармейская, 131',
    city: 'Самара',
    name: 'Мягкий кинотеатр Гудок',
    short_name: 'Гудок',
    link: `https://smr.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/gudok.svg',
    // img: '/src/img/test-logos/gudok.svg',
  },
  {
    address: 'Дыбенко, 30',
    city: 'Самара',
    name: 'Мягкий кинотеатр Космопорт',
    short_name: 'Космопорт',
    link: `https://kosmoport.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/kosmoport.svg',
  },
  {
    address: 'Копейское шоссе, д.64',
    city: 'Челябинск',
    name: 'Мягкий кинотеатр Алмаз',
    short_name: 'Алмаз',
    link: `https://almaz.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/almaz.svg',
    // img: '/src/img/test-logos/almaz.svg',
  },
  {
    address: 'Свердловское шоссе, д.31В',
    city: 'Нижний Тагил',
    name: 'Мягкий кинотеатр DEPO',
    short_name: 'DEPO',
    link: `https://tag.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/depo.svg',
    // img: '/src/img/test-logos/depo.svg',
  },
  {
    address: 'Свердловский проспект, д.51А',
    city: 'Челябинск',
    name: 'Мягкий кинотеатр Мегаполис',
    short_name: 'Мегаполис',
    link: `https://mega.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/mega.svg',
    // img: '/src/img/test-logos/mega.svg',
  },
  {
    address: 'ул.Менделеева, д.137',
    city: 'Уфа',
    name: 'Мягкий кинотеатр Мегаполис Уфа',
    short_name: 'Мегаполис Уфа',
    link: `https://ufa.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/mega_ufa.svg',
    // img: '/src/img/test-logos/mega_ufa.svg',
  },
  {
    address: 'пр-т К.Маркса, 172',
    city: 'Магнитогорск',
    name: 'Мягкий кинотеатр Семейный парк',
    short_name: 'Семейный парк',
    link: `https://mgn.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/semeynyi.svg',
    // img: '/src/img/test-logos/semeynyi.svg',
  },
  {
    address: 'ул. Молдавская, 16 (3 этаж)',
    city: 'Челябинск',
    name: 'Мягкий кинотеатр Фокус',
    short_name: 'Фокус',
    link: `https://fokus.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/focus.svg',
    // img: '/src/img/test-logos/focus.svg',
  },
  {
    address: 'МО, г.о. Красногорск, пос. Отрадное, Пятницкое ш., д.1, стр.1',
    city: 'Москва',
    name: 'Мягкий кинотеатр Отрада',
    short_name: 'Отрада',
    link: `https://otrada.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/otrada.svg',
    // img: '/src/img/test-logos/otrada.svg',
  },
  {
    address: 'пр-т Космонавтов, 108',
    city: 'Екатеринбург',
    name: 'Мягкий кинотеатр Веер',
    short_name: 'Веер',
    link: `https://veer.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/veer.svg',
    // img: '/src/img/test-logos/veer.svg',
  },
  {
    address: 'ул. Спешилова, 114',
    city: 'Пермь',
    name: 'Мягкий кинотеатр СпешиLove',
    short_name: 'СпешиLove',
    link: `https://speshilove.${process.env.REACT_APP_COMFORTKINO_URL}`,
    img: '/local/templates/comfortkino/static/img/logos/svg/speshilove.svg',
    // img: '/src/img/test-logos/speshilove.svg',
  },
];
